export type SubTemplate = {
  data: Record<string, any>;
  id: string;
  subTemplateId: string;
};

export type PdfLibConfig = {
  format?: string;
  height?: string;
  landscape?: boolean;
  width?: string;
};

export type PdfTemplateGenerationConfig = PdfLibConfig & {
  strict?: boolean;
};

export abstract class BasePDFTemplateRequest {
  readonly template: string;

  data: Record<string, any>;

  includePublicUrl: boolean;

  subTemplates: SubTemplate[];

  options?: PdfTemplateGenerationConfig;

  protected constructor(template: string) {
    this.template = template;
    this.data = {};
    this.subTemplates = [];
    this.includePublicUrl = true;
  }

  setOptions(options?: PdfTemplateGenerationConfig) {
    this.options = options;
    return this;
  }

  protected toAPIRequest() {
    return {
      data: this.data,
      includePublicUrl: this.includePublicUrl,
      options: this.options,
      subTemplates: this.subTemplates,
      template: this.template
    };
  }
}
